module.exports = __webpack_public_path__ + "img/default_img5.93ec7a13.webp";